export default __webpack_public_path__ + "static/bryan-deferm-1301adb5908b8d0dc262f2fb1256f76e.jpeg";